import { getNativeAppVersion } from "@infrastructure/Helpers/GetNativeAppVersion";

export const isSharingNativelySupported = () => {
    const appVersion = getNativeAppVersion();
    if (!appVersion) {
        return false;
    }
    return (
        appVersion.major > 2025 ||
        (appVersion.major === 2025 && appVersion.minor >= 100)
    );
};
